import axiosInstance from '../axiosInterceptor/axiosInstance'

// Everything the FIBA statistics sheet needs for a game: the boxscore, the game's header and the
// play-by-play derived numbers. Read under the org whose CMS is shown (a paired club passes the
// federation).
const getGameStatsSheet = async ({ gameId, orgId }) => {
  const response = await axiosInstance.get(`v1/orgs/${orgId}/stats/games/${gameId}/sheet`)
  return response?.data
}

export default getGameStatsSheet
